import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SUFFIX = 'Whizr';

/**
 * Maps route paths to page titles.
 * More specific paths should come first so they match before generic ones.
 */
const ROUTE_TITLES = [
    // Dashboard - Restaurante
    { match: '/painel/restaurante/cardapio', title: 'Cardápio' },
    { match: '/painel/restaurante/cozinha', title: 'Cozinha' },
    { match: '/painel/restaurante/comandas', title: 'Comandas' },
    { match: '/painel/restaurante/administracao', title: 'Administração' },
    { match: '/painel/restaurante/estatisticas', title: 'Estatísticas Restaurante' },

    // Dashboard
    { match: '/painel/perfil', title: 'Painel' },
    { match: '/painel/resumo', title: 'Resumo' },
    { match: '/painel/produtos', title: 'Produtos' },
    { match: '/painel/eventos', title: 'Eventos' },
    { match: '/painel/financeiro', title: 'Financeiro' },
    { match: '/painel/suporte', title: 'Suporte' },
    { match: '/painel/checkin', title: 'Check-in' },
    { match: '/painel/pedidos', title: 'Pedidos' },
    { match: '/painel/pdv', title: 'PDV' },
    { match: '/painel/estatisticas', title: 'Estatísticas' },

    // User
    { match: '/perfil', title: 'Perfil' },
    { match: '/carteira', title: 'Carteira' },
    { match: '/checkin', title: 'Check-in' },

    // Search
    { match: '/eventos/buscar', title: 'Buscar Eventos' },
    { match: '/estabelecimentos/buscar', title: 'Buscar Estabelecimentos' },

    // Public pages
    { match: '/eventos', title: 'Eventos' },
    { match: '/estabelecimentos', title: 'Estabelecimentos' },
    { match: '/evento/', title: 'Evento' },
    { match: '/estabelecimento/', title: 'Estabelecimento' },
    { match: '/produtor/', title: 'Produtor' },

    // Auth
    { match: '/entrar', title: 'Entrar' },
    { match: '/cadastrar', title: 'Cadastrar' },
    { match: '/recuperar-conta', title: 'Recuperar Conta' },
    { match: '/acesso', title: 'Acesso' },

    // Terms
    { match: '/termos-de-uso', title: 'Termos de Uso' },
    { match: '/politica-de-privacidade', title: 'Política de Privacidade' },
    { match: '/exclusao-de-conta', title: 'Exclusão de Conta' },

    // Misc
    { match: '/quero-ser-parceiro', title: 'Seja Parceiro' },
    { match: '/eventos-em-alta', title: 'Em Alta' },
    { match: '/3-anos-whizr', title: '3 Anos de Whizr' },
];

function getTitleForPath(pathname) {
    for (const route of ROUTE_TITLES) {
        if (pathname.startsWith(route.match)) {
            return `${route.title} - ${SUFFIX}`;
        }
    }
    return SUFFIX;
}

/**
 * Hook that automatically sets document.title based on the current route.
 * Place it once in a component that renders on every route (e.g., AppRoutes).
 */
export default function usePageTitle() {
    const location = useLocation();

    useEffect(() => {
        document.title = getTitleForPath(location.pathname);
    }, [location.pathname]);
}
